import axios from 'axios'
import store from '../store';

export default class StripeService {


    async createPaymentIntent(orderid) {

        const res = await axios({
            method: 'post',
            headers: {
                authorization: store.state.currentUser.token
            },
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/stripe/createpaymentintent',
            data: {
                orderid: orderid
            }
        });

        return res.data;
    }




}